import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { aiMetaExtraReducers } from '@store/reducres/aimeta.reducers'
import { EntityId } from '@reduxjs/toolkit'

export const aIMetadataUrl = 'aimeta/'
export enum AiLinkType {
  INTRO = 'intro',
  OVERVIEW = 'overview',
  OUTRO = 'outro',
  ARTICLE = 'article',
  TRAFFIC = 'traffic',
  WEATHER = 'weather',
  CUSTOM = 'custom',
  PLAYLIST = 'playlist',
  BAND = 'band',
  OVERVIEW_HPSZ = 'overview_hpsz',
}
export enum AILinkStatus {
  NEW = 'NEW',
  OUTLINE_DRAFT = 'OUTLINE_DRAFT',
  OUTLINE_REJECTED = 'OUTLINE_REJECTED',
  OUTLINE_APPROVED = 'OUTLINE_APPROVED',
  TEXTED_DRAFT = 'TEXTED_dRAFT',
  TEXTED_REJECTED = 'TEXTED_REJECTED',
  TEXTED_APPROVED = 'TEXTED_APPROVED',
}
export interface AIMetadataModel extends DjangoModel {
  aiLinkType: AiLinkType
  linkStatus: AILinkStatus
  articleSources: ArticleResource[]
  textSource: string
  textNarratives: string[]
  regionalSignature: boolean
  aiSlot: EntityId
}

export interface ArticleResource {
  id: string
  url: string
  body: string
  summary?: string
  lastUpdateDate: string
}

const {
  slice: AIMetadataSlice,
  thunks: AIMetadataThunks,
  adapter: AIMetadataAdapter,
  selectors,
  actions,
} = createGenericSlice<AIMetadataModel>(
  'aiMetadata',
  aIMetadataUrl,
  {},
  aiMetaExtraReducers
)

export const AIMetadataAdapterExport = AIMetadataAdapter

export const { selectById: selectAIMetadataById } =
  AIMetadataAdapter.getSelectors<RootState>(
    (state: RootState) => state.aiMetadata
  )

export const {
  fetchById: fetchMetadataById,
  fetchAll: fetchAllMetadata,
  update: updateAiMetadata,
  create: createAiMetadata,
} = AIMetadataThunks
export const {
  selectLoading: selectAIMetadataLoading,
  selectIsIdInProgress: selectIsAIMetadataIdInProgress,
  selectError: selectAIMetadataError,
  selectByIds: selectAIMetadataByIds,
} = selectors

export const {
  setInProgress: setAiMetadataInProgress,
  setProgressFinished: setAiMetadataFinished,
} = actions

export default AIMetadataSlice.reducer
